const types = {
  FETCH_PLATE: "FETCH_PLATE",
  FETCH_PERMIT_PLATE: "FETCH_PERMIT_PLATE",
  FETCH_PERMIT_PLATE_CITATIONS: "FETCH_PERMIT_PLATE_CITATIONS",
};

export default types;
